import { getOptionsLabel, getUnitMap } from '@@/utils/getFields'

const optionsLabelFields = {
  'FR-4': [
    'blind', 'board_brand', 'units', 'overlay_type', 'beveledge', 'impendance', 'bankong', 'baobian',
    'user_stamp', 'cross_board', 'paper', 'report_type', 'review_file', 'copper', 'insidecopper'
  ],
  'FPC': [
    'material', 'units', 'back_gum_type', 'electromagnetic_membrane', 'conducting_resin', 'impendance',
    'cross_board', 'report_type', 'copper', 'insidecopper', 'overlay_type'
  ],
  'ROGERS': [
    'board_model', 'carbon_oil', 'blue_glue', 'units', 'overlay_type', 'beveledge', 'impendance', 'bankong', 'baobian',
    'user_stamp', 'cross_board', 'paper', 'report_type', 'review_file', 'copper', 'insidecopper'
  ]
}

// 字段显示格式化
export const fieldsFormat = (type, data) => {
  const types = { 'FR-4': ['FR-4'], 'FPC': ['FPC'], 'ROGERS': ['FR-4', 'ROGERS'] }[type]
  const getValueByKey = key => getOptionsLabel(types, key, data[key])
  const units = getUnitMap(types)
  const hasUnit = key => `${data[key] || '--'}${units[key]}`
  // 需要获取选项对应的值的字段
  const valuesByOptions = optionsLabelFields[type].reduce((acc, key) => {
      acc[key] = getValueByKey(key)
      return acc
    }, {})
  // 统一处理的字段
  const format = {
    blayer: `${data.blayer || '--'} 层`,
    length: `${data.length || '--'}x${data.width || '--'} cm`,
    layout: data.units == 2 ? `${data.layoutx || '--'}x${data.layouty || '--'} Pcs` : 'hide',
    sidewidth: data.units != 3 ? (data.sidedirection === '无' ? '无' : `${getOptionsLabel(types, 'sidewidth', data.sidedirection)}，${data.sidewidth || '--'} mm`) : 'hide',
    bheight: `${data.bheight || '--'} mm`,
    color: 'slot',
    spray: { '沉金': `沉金，厚度${getValueByKey('cjh')}`, '电金': `电金，厚度${getValueByKey('electrogilding_thickness')}` }[data.spray] || data.spray,
    review_file: 'slot',
    report: data.report || '无需',
    report_type: !data.report ? 'hide' : getValueByKey('report_type'),
    lineweight: hasUnit('lineweight'),
    vias: hasUnit('vias'),
    copper: `${data.copper || '--'}oz`,
    insidecopper: data.blayer <= 2 ? 'hide' : `${data.insidecopper || '--'}oz`,
    cover: data.cover
  }
  const typeFormat = {
    'FR-4': {
      board_brand: getValueByKey('board_brand') || data.board_brand,
      deduct_type: 'slot',
      pressing: data.blayer <= 2 ? 'hide' : data.press_name || data.pressing || '无需求',
      insurance_type: getValueByKey('insurance_type')
    },
    'FPC': {
      reinforce: 'slot',
      pi_thickness: hasUnit('pi_thickness'),
    },
    'ROGERS': {
      board_type: `${getValueByKey('board_type')}(${getValueByKey('hybrid_type')})`,
      deduct_type: 'slot',
      pressing: data.blayer <= 2 ? 'hide' : data.press_name || data.pressing || '无需求',
      insurance_type: getValueByKey('insurance_type')
    }
  }[type] || {}

  return {
    ...valuesByOptions,
    ...format,
    ...typeFormat
  }
}